export default __webpack_public_path__ + "static/media/pool1.b732e3e6.jpg";